module.exports = __webpack_public_path__ + "img/bg.bce325ff.jpg";